<template>
  <GenericTabView :tabs="tabsData">
    <template v-slot:tab1>
      <GenericList api-endpoint="device" :data="getSidData()">
        <template v-slot:title-bar><div style="display: none" /></template>
        <template v-slot:header>
          <DeviceHeader />
        </template>
        <template v-slot:item="{ item, index }">
          <DeviceItem :item="item" :index="index" :operation="false" />
        </template>
      </GenericList>
    </template>
    <template v-slot:tab2 v-if="getPermission() < 3">
      <GenericGroup api-endpoint="device" ref="GenericGroup" v-if="type === 2">
        <template v-slot:uninclude-title>{{ $t('unbound') }}</template>
        <template v-slot:include-title>{{ $t('bound') }}</template>
        <template v-slot:uninclude-item="{ item, index }">
          <GroupItem
            :mainId="id"
            :item="item"
            :index="index"
            :type="0"
            @add-group="addGroup"
            @remove-group="removeGroup"
          />
        </template>
        <template v-slot:include-item="{ item, index }">
          <GroupItem
            :mainId="id"
            :item="item"
            :index="index"
            :type="1"
            @add-group="addGroup"
            @remove-group="removeGroup"
          />
        </template>
      </GenericGroup>
    </template>
  </GenericTabView>
</template>

<script>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ref, inject, onMounted } from 'vue';
import GenericTabView from '../generic/GenericTabView.vue';
import GenericList from '../generic/GenericList.vue';
import GenericGroup from '../generic/GenericGroup.vue';
import GroupItem from './GroupItem.vue';
import DeviceHeader from '../device/DeviceHeader.vue';
import DeviceItem from '../device/DeviceItem.vue';
import { getPermission } from '../../User';

export default {
  components: {
    GenericTabView,
    GenericList,
    GenericGroup,
    GroupItem,
    DeviceHeader,
    DeviceItem,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      errorNameMessage: '',
      title: this.$t('confirmAdd'),
    };
  },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const page = ref('fileGroup');
    const apiBaseUrl = inject('apiBaseUrl');
    const id = ref(0);
    const tabsData = ref([
      {
        name: 'tab1',
        title: t('deviceList'),
      },
      {
        name: 'tab2',
        title: t('deviceBinding'),
      },
    ]);
    onMounted(() => {
      id.value = route.params.id;
      const permission = getPermission();
      if (permission > 2) {
        tabsData.value.pop();
      }
    });
    return {
      t,
      page,
      apiBaseUrl,
      id,
      route,
      tabsData,
    };
  },
  methods: {
    getPermission,
    getSidData() {
      return JSON.stringify({
        sid: this.route.params.id,
      });
    },
    getProjectData() {
      return JSON.stringify({
        project: this.route.params.id,
      });
    },
    removeGroup(item) {
      if (this.$refs.GenericGroup) {
        this.$refs.GenericGroup.removeGroup(item);
      }
    },
    addGroup(item) {
      if (this.$refs.GenericGroup) {
        this.$refs.GenericGroup.addGroup(item);
      }
    },
  },
};
</script>

<style></style>
